module.exports = __webpack_public_path__ + "static/media/m_hairstyle_buzz_front.2d8e895a.png";